<template>
  <button class="primary icon" v-tooltip="tooltip">
      <font-awesome-icon :icon="icon" :size="$attrs.size" :class="$attrs.class"></font-awesome-icon>
  </button>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
    icon: String,
    tooltip: String
})
</script>


